<template>
  <div class="row">
    <div class="col-12 mb-3 text-end">
      <a
        class="btn btn-outline-primary"
        target="_blank"
        :href="`/home/courses/${course.id}/preview/${lecture.id}`"
      >
        {{ 'Preview' | translate }}
      </a>
    </div>
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h5>{{ 'Lecture' | translate }}</h5>
        </div>
        <div class="card-body">
          <div
            class="me-auto d-flex flex-row align-items-center"
            v-if="lecture.editing"
          >
            {{ 'Title' | translate }}:
            <input
              type="text"
              class="form-control"
              v-model="lecture.title"
              @keyup.enter="initiateUpdate"
            />
            <button class="btn btn-text text-success" @click="initiateUpdate">
              <i class="fas fa-check-circle"></i>
            </button>
            <button class="btn btn-text text-danger" @click="cancelEditing">
              <i class="fas fa-times-circle"></i>
            </button>
          </div>
          <div class="me-auto" v-else>
            {{ 'Title' | translate }}: {{ lecture.title }}
            <button class="btn btn-text">
              <i class="fas fa-pencil-alt" @click="editTitle"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 d-md-none">
      <div class="dropdown mt-3">
        <button
          class="btn btn-primary dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ 'Add new component' | translate }}
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a
            href="#"
            @click.prevent="addComponent('text')"
            class="dropdown-item"
          >
            {{ 'Text' | translate }}
          </a>
          <a
            href="#"
            @click.prevent="addComponent('image')"
            class="dropdown-item"
          >
            {{ 'Image' | translate }}
          </a>
          <a
            href="#"
            @click.prevent="addComponent('html')"
            class="dropdown-item"
          >
            HTML
          </a>
          <a
            href="#"
            @click.prevent="addComponent('code')"
            class="dropdown-item"
          >
            {{ 'Code' | translate }}
          </a>
          <a
            href="#"
            @click.prevent="addComponent('file')"
            class="dropdown-item"
          >
            {{ 'File' | translate }}
          </a>
          <a
            href="#"
            @click.prevent="addComponent('video')"
            class="dropdown-item"
          >
            {{ 'Video' | translate }}
          </a>
          <a
            href="#"
            @click.prevent="addComponent('quiz')"
            class="dropdown-item"
          >
            Quiz
          </a>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="row">
        <div class="col d-none d-md-block">
          <div class="list-group mt-3 sticky-top">
            <div>
              <draggable
                :group="{
                  name: 'components',
                  pull: 'clone',
                  put: false,
                }"
                :list="elements"
                :sort="false"
                :clone="handleElementAdd"
              >
                <div
                  v-for="el in elements"
                  :key="el.type"
                  class="list-group-item list-group-item-action grabbable text-uppercase"
                >
                  {{ el.type | translate }}
                </div>
              </draggable>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div v-if="!lecture.components.length" class="my-3 text-center">
            <a href="#" data-bs-toggle="modal" data-bs-target="#showHow">
              {{ 'Drag and drop elements here' | translate }}
            </a>
            <br />
            <i class="fas fa-arrow-down"></i>
            <div
              class="modal fade"
              id="showHow"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <img
                      src="https://djceg34j53tq.cloudfront.net/public/gif-na-strone-dodawania-lekcji.gif"
                      alt
                      class="img-fluid"
                    />
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-primary"
                      data-bs-dismiss="modal"
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <draggable
            :list="lecture.components"
            @change="initiateUpdateComponentsOrder"
            handle=".grabbable"
            group="components"
          >
            <LectureComponent
              v-for="component in lecture.components"
              :key="component.id"
              :component-data="component"
              :course-data="course"
              :section-data="section"
              :lecture-data="lecture"
              @remove="removeComponent"
            ></LectureComponent>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import LectureComponent from './lectureComponents/LectureComponent'
import route from './../routes.js'
import _ from 'lodash'

export default {
  components: {
    draggable,
    LectureComponent,
  },
  props: ['dataSection', 'dataCourse', 'dataLecture'],
  data() {
    return {
      elements: [
        { type: 'text' },
        { type: 'image' },
        { type: 'html' },
        { type: 'code' },
        { type: 'file' },
        { type: 'video' },
        { type: 'quiz' },
        { type: 'assignment' },
      ],
      course: this.dataCourse,
      section: this.dataSection,
      lecture: this.dataLecture,
    }
  },
  methods: {
    handleElementAdd({ type }) {
      switch (type) {
        case 'text':
          return {
            type,
            quill:
              '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
            html: '<h2>Sample Header</h2><p>Sample Text</p>',
          }
          break

        case 'assignment':
          return {
            type,
            data: {
              assignment: {
                quill:
                  '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
                html: '<h2>Sample Header</h2><p>Sample Text</p>',
              },
              solution: {
                quill:
                  '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
                html: '<h2>Sample Header</h2><p>Sample Text</p>',
              },
            },
          }
          break

        case 'quiz':
          return {
            type,
            data: {
              question: {
                quill:
                  '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
                html: '<h2>Sample Header</h2><p>Sample Text</p>',
              },
              answers: [
                {
                  label: '',
                  correct: true,
                },
                {
                  label: '',
                  correct: false,
                },
              ],
              solution: {
                quill:
                  '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
                html: '<h2>Sample Header</h2><p>Sample Text</p>',
              },
            },
          }
          break

        default:
          return {
            type,
          }
          break
      }
    },
    handleError(error) {
      if (error.response && error.response.status === 419) {
        this.$root.$emit(
          'flash',
          this.$t('Your session has expired - please reload'),
          'warning',
        )
      } else {
        iziToast.error({
          title: 'Error',
          message: this.$t('Something went wrong'),
          position: 'topRight',
        })
        console.error(error)
      }
    },
    initiateUpdate() {
      this.$set(this.lecture, 'editing', false)
      if (this.lecture.title === '') {
        iziToast.warning({
          title: 'Warning',
          message: this.$t('Title can not be empty'),
          position: 'topRight',
        })
        this.cancelEditing()
        return false
      }
      this.update()
        .then((response) => {
          this.lecture = response.data
          this.$root.$emit('flash', this.$t('Saved'))
        })
        .catch((error) => {
          this.handleError()
          this.cancelEditing()
        })
    },
    update() {
      return axios.put(
        route.lecture(this.course, this.section, this.lecture).update,
        {
          lecture: this.lecture,
          section: false,
        },
      )
    },
    cancelEditing() {
      this.lecture = this.previousLectureState
    },
    editTitle() {
      this.previousLectureState = _.cloneDeep(this.lecture)
      this.$set(this.lecture, 'editing', true)
    },
    addComponent(type) {
      switch (type) {
        case 'text':
          this.storeComponent({
            type,
            quill:
              '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
            html: '<h2>Sample Header</h2><p>Sample Text</p>',
          })
          break

        case 'quiz':
          this.storeComponent({
            type,
            data: {
              question: {
                quill:
                  '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
                html: '<h2>Sample Header</h2><p>Sample Text</p>',
              },
              answers: [
                {
                  label: 'Answer 1',
                  correct: true,
                },
                {
                  label: 'Answer 2',
                  correct: false,
                },
              ],
              solution: {
                quill:
                  '{"ops":[{"insert":"Sample Header"},{"attributes":{"header":2},"insert":"\\n"},{"insert":"Sample Text\\n"}]}',
                html: '<h2>Sample Header</h2><p>Sample Text</p>',
              },
            },
          })
          break

        default:
          this.storeComponent({
            type,
          })
          break
      }
    },

    storeComponent(newComponent) {
      axios
        .post(
          route.component(this.course, this.section, this.lecture).store,
          newComponent,
        )
        .then((response) => {
          let component = response.data
          this.lecture.components.push(component)
        })
        .catch(this.handleError)
    },

    storeAndUpdate(component) {
      return axios.post(
        route.component(this.course, this.section, this.lecture).store,
        component,
      )
    },

    initiateUpdateComponentsOrder(e) {
      if (e.added) {
        this.lecture.components.map((c, i) => {
          c.sort_order = i
        })

        this.storeAndUpdate(e.added.element)
          .then((response) => response.data)
          .then((component) => {
            return this.$set(
              this.lecture.components,
              e.added.element.sort_order,
              { ...e.added.element, ...component },
            )
          })
          .then(() => {
            return this.updateComponentOrder()
          })
          .then((response) => {
            this.$root.$emit('flash', this.$t('Saved'))
          })
          .catch(this.handleError)
      }

      if (e.moved) {
        this.updateComponentOrder()
          .then((response) => {
            this.$root.$emit('flash', this.$t('Saved'))
          })
          .catch(this.handleError)
      }
    },

    updateComponentOrder() {
      this.lecture.components.map((c, i) => {
        c.sort_order = i
      })

      return axios.patch(
        route.component(this.course, this.section, this.lecture).order,
        _.sortBy(this.lecture.components, (c) => c.id),
      )
    },

    removeComponent(component) {
      this.$set(
        this.lecture,
        'components',
        _.reject(this.lecture.components, (c) => c.id === component.id),
      )
      this.$root.$emit('flash', this.$t('Deleted'))
    },
  },
}
</script>
